var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDivider(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 16,
    viewBox: "0 0 140 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83592 10.0972C5.34646 8.68154 8.27427 6.79645 9.09201 9.72628C9.625 11.6341 7.60986 13.0952 6.00358 11.8233C1.95868 8.62097 6.08389 -0.0549552 19.7153 6.35736C33.3468 12.7697 54.1554 18.4779 63.4718 12.4366C69.1303 8.76481 59.3466 2.57205 38.4212 6.35736C17.5031 10.1351 -4.21819 4.38143 2.11931 1.75442C8.4568 -0.872581 18.131 3.73035 37.786 9.80956C57.441 15.8888 69.6122 4.42685 69.6122 4.42685H69.4808C69.4808 4.42685 81.6447 15.8888 101.307 9.80956C120.962 3.73035 130.636 -0.872581 136.974 1.75442C143.318 4.38143 121.597 10.1351 100.672 6.35736C79.7463 2.57962 69.9626 8.77238 75.6211 12.4366C84.9375 18.4779 105.746 12.7621 119.378 6.35736C133.009 -0.0549552 137.134 8.62097 133.089 11.8233C131.483 13.0952 129.461 11.6416 130.001 9.72628C130.819 6.79645 133.746 8.68154 132.257 10.0972",
    stroke: "#F4B41A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.7f1b0761780119a75f5737cef2c0de1a.svg";
export { ForwardRef as ReactComponent };